import { apiCall, apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";

export const createDockSetupApi = async (data) => {
  const response = await apiCall("POST", "dockmaster", data);
  return response;
};

export const createAutoSetupApi = async (data) => {
  const response = await apiCallAdmin("POST", "auto_mail_trigger", data);
  return response;
};

export const updateAutoSetupApi = async (id, data) => {
  const response = await apiCallAdmin("PUT", `auto_mail_trigger/${id}`, data);
  return response;
};

export const updateDockSetupApi = async (id, data) => {
  const response = await apiCall("PUT", `dockmaster/${id}`, data);
  return response;
};

export const getUserApi = async (term) => {
  const response = await apiCallAdmin("GET", `employee/autocomplete?term=${term}`);
  return response;
};

export const createVehicleTypeApi = async (data) => {
  const response = await apiCall("POST", "vehicletype", data);
  return response;
};

export const updateVehicleTypApi = async (id, data) => {
  const response = await apiCall("PUT", `vehicletype/${id}`, data);
  return response;
};

export const getVehicleTypeApi = async (id) => {
  const response = await apiCall("GET", `vehicletype/get/${id}`);
  return response;
};

export const getDockMasterListApi = async (params) => {
  const response = await apiCall("GET", `dockmaster?${params}`);
  return response;
};

export const getVehicleTypeListApi = async (params) => {
  const response = await apiCall("GET", `vehicletype?${params}`);
  return response;
};

export const getDockGateApi = async (id) => {
  const response = await apiCall("GET", `dockmaster/get/${id}`);
  return response;
};

export const getTiggerApi = async (id) => {
  const response = await apiCallAdmin("GET", `auto_mail_trigger/${id}`);
  return response;
};

export const getDeleteApi = async (deleteUrl) => {
  const response = await apiCallGeneric("DELETE", deleteUrl);
  return response;
};

export const getDeleteAdminApi = async (deleteUrl) => {
  const response = await apiCallGeneric("DELETE", deleteUrl);
  return response;
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  const response = await apiCallGeneric("DELETE", deleteUrl, { id: ids });
  return response;
};

export const downloadExcelApi = async (apivalue) => {
  const response = await apiCall("GET", apivalue);
  return response;
};

export const uploadExcelApi = async (apivalue, base64String) => {
  const response = await apiCall("POST", apivalue, { file: base64String });
  return response;
};

export const downloadTemplateExcelApi = async (mater_type) => {
  const response = await apiCall("POST", "master_import/template_download", {
    type: mater_type,
  });
  return response;
};

export const downloadDashboardExcelApi = async (apivalue) => {
  const response = await apiCall("GET", apivalue);
  return response;
};

export const downloadDashboardExcelPostApi = async (apivalue, payload) => {
  const response = await apiCall("POST", apivalue, payload);
  return response;
};
